import { Image, Text, View } from "@react-pdf/renderer";

export default function ShipmentPdfHeader({
  locationLogo,
  locationInfo,
  logo,
  styles,
  shipment,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */
  const convertSqlTimestampToDate = (sqlTime) => {
    const timestamp = sqlTime;
    const date = new Date(timestamp);
    const time = date.toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return time.replaceAll("/", "-");
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <>
      <View style={{ ...styles.topHeader, marginBottom: 0 }}>
        {/*   Top Header Section
         ********************************************* */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* Left side - Location Logo */}
          <View style={{ width: "30%" }}>
            {locationLogo ? (
              <Image
                src={locationLogo}
                style={{
                  width: 120,
                  height: 50,
                  objectFit: "contain",
                }}
              />
            ) : (
              <Image
                src={logo}
                style={{
                  width: 120,
                  height: 50,
                  objectFit: "contain",
                }}
              />
            )}
          </View>

          {/* Right side - Shipment ID and Dates */}
          <View
            style={{
              alignItems: "flex-end",
            }}
          >
            <Text style={[styles.headingMain, { marginBottom: 2 }]}>
              S-{shipment?.shipmentId}
            </Text>
            <View
              style={{
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Text style={[styles.headingSecond]}>
                Print Date : {convertSqlTimestampToDate(Date.now())}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
}
